var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"stats ml-sm-auto px-4 text-center",attrs:{"cols":"9","md":"10"}},[_c('h1',[_vm._v("Вам нужно авторизоваться!")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.showModal}},[_vm._v("Войти")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }